/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BatchWriteSupportConfig
 */
export interface BatchWriteSupportConfig {
    /**
     * Whether this type of batch write operation is supported
     * @type {boolean}
     * @memberof BatchWriteSupportConfig
     */
    supported: boolean;
    /**
     * The default number of records supported in a batch
     * @type {number}
     * @memberof BatchWriteSupportConfig
     */
    defaultRecordLimit?: number;
    /**
     * Defines object-level overrides for batch record limits. Keys represent object names, and values specify the maximum number of records per batch for those objects.
     * @type {{ [key: string]: number; }}
     * @memberof BatchWriteSupportConfig
     */
    objectRecordLimits?: { [key: string]: number; };
}

/**
 * Check if a given object implements the BatchWriteSupportConfig interface.
 */
export function instanceOfBatchWriteSupportConfig(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "supported" in value;

    return isInstance;
}

export function BatchWriteSupportConfigFromJSON(json: any): BatchWriteSupportConfig {
    return BatchWriteSupportConfigFromJSONTyped(json, false);
}

export function BatchWriteSupportConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchWriteSupportConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'supported': json['supported'],
        'defaultRecordLimit': !exists(json, 'defaultRecordLimit') ? undefined : json['defaultRecordLimit'],
        'objectRecordLimits': !exists(json, 'objectRecordLimits') ? undefined : json['objectRecordLimits'],
    };
}

export function BatchWriteSupportConfigToJSON(value?: BatchWriteSupportConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'supported': value.supported,
        'defaultRecordLimit': value.defaultRecordLimit,
        'objectRecordLimits': value.objectRecordLimits,
    };
}

